// MontosPage.js
import React, { useState, useEffect } from 'react';
import { 
    Box, TextField, Button, IconButton, Modal, Switch,Checkbox,
    Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import LockResetIcon from '@mui/icons-material/LockReset';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Container } from '@mui/material';
import DataTable from 'react-data-table-component';
import { AmountService } from '../../services/amountService';
import { toast, ToastContainer } from 'react-toastify';
import FormControlLabel from '@mui/material/FormControlLabel';


const MontosPage = () => {
    const [montos, setMontos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [amountToDelete, setAmountToDelete] = useState(null);

    const [monto, setAmount] = useState('');
    const [isPercent, setIsPercent] = useState(false);
    const [isMax, setIsMax] = useState(false);
    const [isMin, setIsMin] = useState(false);


    useEffect(() => {
        fetchMontos();
      }, []);

    const today = new Date();

    const getStatusText = (idStatus) => {
        return idStatus === 1 ? 'Activo' : 'Inactivo';
    };

    const fetchMontos = async () => {
        try {
          setLoading(true);
          const data = await AmountService.getAllAmount();
          setMontos(data);
          setLoading(false);
        } catch (err) {
          setError('Error al cargar los roles');
          setLoading(false);
        }
      };

    const handleSaveAmount = async () => {
        var amountDTO = {
            amount:monto,
            isPercent,
            isMax,
            isMin
          }
          try {
            if (selectedAmount) {
              await AmountService.editAmount(selectedAmount.id, amountDTO);
            } else {
              await AmountService.createAmount(amountDTO);
            }
            setIsModalOpen(false);
            fetchMontos();
            toast.success('Monto guardado con éxito');
          } catch (err) {
            setError('Error al guardar el monto');
          }
    }

    const handleViewDetail = (amount) => {
       setSelectedAmount(amount);
       setIsDetailModalOpen(true);
    };

    const handleEdit = (amount) => {
        setSelectedAmount(amount);
        setAmount(amount.amount);
        setIsPercent(amount.isPercent);
        setIsMax(amount.isMax);
        setIsMin(amount.isMin);
        setIsModalOpen(true);
    };

    const handleDelete = (amount) => {
      setAmountToDelete(amount);
      setIsDeleteDialogOpen(true);
    };

    const handleAdd = () => {
        setSelectedAmount(null);
        setAmount('');
        setIsPercent(false);
        setIsMax(false);
        setIsMin(false);
        setIsModalOpen(true);
    };

    const handleChangePercent = (event) => {
      setIsPercent(event.target.checked);
    };

    const handleChangeMax = (event) => {
      setIsMax(event.target.checked);
    };

    const handleChangeMin = (event) => {
      setIsMin(event.target.checked);
    };
    
    const confirmDelete = async () => {
      await AmountService.deleteAmount(amountToDelete.id)
      fetchMontos();
      setIsDeleteDialogOpen(false);
    };

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'cantidad',
            selector: row => row.amount,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Porcentaje',
            selector: row => row.isPercent,
            sortable: true,
            cell: row => (
                <Checkbox checked={row.isPercent}/>
            ),
        },
        {
            name: 'Maximo',
            selector: row => row.isMax,
            sortable: true,
            cell: row => (
                <Checkbox checked={row.isMax}/>
            ),
        },
        {
            name: 'Minimo',
            selector: row => row.isMin,
            sortable: true,
            cell: row => (
                <Checkbox checked={row.isMin}/>
            ),
        },
        {
            name: 'Estado',
            selector: row => getStatusText(row.idStatus),
            sortable: true,
            cell: row => (
            <span className={`apple-badge ${row.idStatus === 1 ? 'apple-badge-success' : 'apple-badge-error'}`}>
                {getStatusText(row.idStatus)}
            </span>
            ),
        },
        {
            name: 'Acciones',
            cell: row => (
            <Box>
                <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
                <VisibilityIcon fontSize="small" />
                <span className="tooltiptext">Ver Detalle</span>
                </IconButton>
                <IconButton onClick={() => handleEdit(row)} size="small" className="apple-button apple-tooltip">
                <EditIcon fontSize="small" />
                <span className="tooltiptext">Editar</span>
                </IconButton>
                <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
                <RemoveCircleOutlineIcon fontSize="small" color='error'/>
                <span className="tooltiptext">Desactivar</span>
                </IconButton>
            </Box>
            ),
            width: '200px',
        },
    ];

    const customStyles = {
        table: {
          style: {
            minWidth: '100%',
          },
        },
        headRow: {
          style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
          },
        },
        headCells: {
          style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
          },
        },
        cells: {
          style: {
            fontSize: '14px',
            color: '#1D1D1F',
          },
        },
    };

    const filteredItems = montos.filter(
      item => (item.id && item.id.toLocaleString().toLowerCase().includes(filterText.toLowerCase()))
    );

    const subHeaderComponentMemo = React.useMemo(() => {
        return (
          <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
            <div className="apple-search-container">
              <SearchIcon className="apple-search-icon" />
              <input
                type="text"
                placeholder="Buscar por ID"
                onChange={e => setFilterText(e.target.value)}
                className="apple-search-input"
              />
            </div>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAdd}
              className="apple-button"
            >
              Agregar Monto
            </Button>
          </Box>
        );
      }, [filterText]);

    return (
        <div className="apple-container">
        <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
        </Paper>

        {/* Modal para editar/crear rol */}
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
         <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
        }}>
          <Typography id="modal-modal-title" className="apple-modal-title">
            {selectedAmount ? 'Editar Monto' : 'Agregar Nuevo Monto'}
          </Typography>
          <div className="apple-modal-content">
            <TextField
              label="Descripción Corta"
              variant="outlined"
              fullWidth
              className="apple-input"
              defaultValue={monto}
              onChange={(e) => setAmount(e.target.value)}
            />
            <FormControlLabel control={<Checkbox checked={isPercent} onChange={handleChangePercent}/>} label="¿Es porcentaje?" />
            
            <FormControlLabel control={<Checkbox checked={isMax} onChange={handleChangeMax}/>} label="¿Es Máximo?" />
            
            <FormControlLabel control={<Checkbox checked={isMin} onChange={handleChangeMin} />} label="¿Es Mínimo?" />
            
          </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsModalOpen(false)} className="apple-button">
              Cancelar
            </Button>
            <Button variant="contained" className="apple-button" onClick={() => handleSaveAmount()}>
              {selectedAmount ? 'Guardar Cambios' : 'Crear Monto'}
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
        }}>
          <Typography id="modal-modal-title" className="apple-modal-title">
            Detalles del Monto
          </Typography>
          <div className="apple-modal-content">
            <TextField
              label="ID"
              fullWidth
              value={selectedAmount?.id}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="Monto"
              fullWidth
              value={selectedAmount?.amount}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            
            <FormControlLabel control={<Checkbox checked={selectedAmount?.isPercent != 0} readOnly/>} label="¿Es porcentaje?" />
            
            <FormControlLabel control={<Checkbox checked={selectedAmount?.isMax != 0} readOnly/>} label="¿Es Máximo?" />
            
            <FormControlLabel control={<Checkbox checked={selectedAmount?.isMin != 0} readOnly/>} label="¿Es Mínimo?" />
           
            <TextField
              label="Fecha de Creación"
              fullWidth
              value={new Date(selectedAmount?.create_At).toLocaleString()}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />

            </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsDetailModalOpen(false)} className="apple-button">
              Cerrar
            </Button>
          </div>
        </Box>
      </Modal>
      {/* Diálogo de confirmación para eliminar */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro de que desea eliminar este Monto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteDialogOpen(false)} className="apple-button">Cancelar</Button>
          <Button onClick={confirmDelete} className="apple-button" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <footer >
        <p>© {today.getFullYear()} Generador de Contratos. Todos los derechos reservados Grupo Defensa. Desarrollado por Gerencia IT </p>
      </footer>
        </div>

    );
};

export default MontosPage;